export default function getLocationAlias() {
  const alias = document.body.getAttribute('data-alias');
  const { pathname } = new URL(document.location.href);

  return alias || pathname;
}
